import Constants, { AppOwnership } from 'expo-constants'

const expoExtras = Constants?.expoConfig?.extra ?? {}

const API_URL = expoExtras.API_URL || process.env.API_URL
const BRANCH_REDIRECT_URI = expoExtras.BRANCH_REDIRECT_URI || process.env.BRANCH_REDIRECT_URI
const ENVIRONMENT = expoExtras.ENVIRONMENT || process.env.ENVIRONMENT
const MAGIC_PUBLISHABLE_KEY =
  expoExtras.MAGIC_PUBLISHABLE_KEY || process.env.MAGIC_PUBLISHABLE_KEY || 'jest_test_key'
const REACTOTRON = expoExtras.REACTOTRON || process.env.REACTOTRON
const TEST = expoExtras.TEST || process.env.TEST
const WEB_APP_VERSION = expoExtras.WEB_APP_VERSION || process.env.WEB_APP_VERSION
const GOOGLE_MAPS_API_KEY = expoExtras.GOOGLE_MAPS_API_KEY || process.env.GOOGLE_MAPS_API_KEY

export const ENV = {
  API_URL,
  BRANCH_REDIRECT_URI,
  ENVIRONMENT,
  // In order to pass jest tests need to add default key
  MAGIC_PUBLISHABLE_KEY,
  REACTOTRON,
  TEST,
  WEB_APP_VERSION,
  GOOGLE_MAPS_API_KEY,
}

export const isDevelopment = __DEV__ || process.env.NODE_ENV === 'development'
export const isProduction = ENV.ENVIRONMENT === 'prod' || process.env.NODE_ENV === 'production'
export const isExpoGo = Constants.appOwnership === AppOwnership.Expo
